export {
  now,
  timer,
  timerFlush
} from "./src/timer";

export {
  default as timeout
} from "./src/timeout";

export {
  default as interval
} from "./src/interval";



//////////////////
// WEBPACK FOOTER
// ./~/d3-timer/index.js
// module id = 351
// module chunks = 3